(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bie-coded-homepage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.pixelReady === 'true') return;
      root.dataset.pixelReady = 'true';

      const getStep = (slider) => {
        const viewport = slider?.querySelector('.pixel-slider-viewport');
        const first = slider?.querySelector('.pixel-slide');
        if (!viewport || !first) return { viewport, step: 0 };
        const track = slider.querySelector('.pixel-track');
        const styles = track ? getComputedStyle(track) : null;
        const gap = styles ? parseFloat(styles.columnGap || styles.gap || '0') || 0 : 0;
        return { viewport, step: first.getBoundingClientRect().width + gap };
      };

      root.addEventListener('click', (event) => {
        const arrow = event.target.closest('[data-pixel-prev], [data-pixel-next]');
        if (!arrow || !root.contains(arrow)) return;
        const slider = arrow.closest('[data-pixel-slider]');
        const { viewport, step } = getStep(slider);
        if (!viewport) return;
        const direction = arrow.hasAttribute('data-pixel-prev') ? -1 : 1;
        const distance = step > 0 ? step : Math.max(220, viewport.clientWidth * 0.82);
        viewport.scrollBy({ left: direction * distance, behavior: 'smooth' });
      });

      const setupDots = (slider) => {
        const dots = slider.querySelector('[data-pixel-dots]');
        const { viewport, step } = getStep(slider);
        const slides = [...slider.querySelectorAll('.pixel-slide')];
        if (!dots || !viewport || !slides.length || !step) return;
        const mobileOnly = slider.dataset.dotsMode === 'mobile';
        const rebuild = () => {
          if (mobileOnly && window.innerWidth > 767) { dots.replaceChildren(); return; }
          const visible = Math.max(1, Math.floor((viewport.clientWidth + 1) / step));
          const pages = Math.max(1, Math.ceil(slides.length / visible));
          if (dots.children.length !== pages) {
            dots.replaceChildren();
            for (let i = 0; i < pages; i += 1) {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'pixel-dot';
              dot.setAttribute('aria-label', `Go to slide group ${i + 1}`);
              dot.addEventListener('click', () => viewport.scrollTo({ left: i * visible * step, behavior: 'smooth' }));
              dots.appendChild(dot);
            }
          }
          const page = Math.min(pages - 1, Math.max(0, Math.round(viewport.scrollLeft / (visible * step))));
          [...dots.children].forEach((dot, i) => dot.classList.toggle('is-active', i === page));
        };
        let raf = 0;
        viewport.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(rebuild); }, { passive: true });
        window.addEventListener('resize', rebuild, { passive: true });
        rebuild();
      };

      root.querySelectorAll('[data-pixel-slider]').forEach(setupDots);

      root.querySelectorAll('[data-pixel-drag-desktop="true"] .pixel-slider-viewport').forEach((viewport) => {
        let down = false; let startX = 0; let startLeft = 0;
        viewport.addEventListener('pointerdown', (event) => {
          if (window.innerWidth <= 767 || event.pointerType === 'touch') return;
          down = true; startX = event.clientX; startLeft = viewport.scrollLeft;
          viewport.setPointerCapture?.(event.pointerId);
        });
        viewport.addEventListener('pointermove', (event) => {
          if (!down) return;
          viewport.scrollLeft = startLeft - (event.clientX - startX);
        });
        const stop = () => { down = false; };
        viewport.addEventListener('pointerup', stop);
        viewport.addEventListener('pointercancel', stop);
        viewport.addEventListener('lostpointercapture', stop);
      });

      root.addEventListener('change', (event) => {
        const radio = event.target.closest('[data-pixel-option-value]');
        if (!radio || !root.contains(radio)) return;
        const card = radio.closest('[data-pixel-product-card]');
        if (!card) return;
        const jsonNode = card.querySelector('[data-pixel-variants-json]');
        if (!jsonNode) return;
        let variants = [];
        try { variants = JSON.parse(jsonNode.textContent || '[]'); } catch (error) { return; }
        const selected = [...card.querySelectorAll('[data-option-position]')].map((group) => group.querySelector('[data-pixel-option-value]:checked')?.value || '');
        const variant = variants.find((item) => Array.isArray(item.options) && item.options.every((value, index) => value === selected[index]));
        if (!variant) return;
        const hidden = card.querySelector('[data-pixel-variant-id]');
        const button = card.querySelector('[data-pixel-atc]');
        const price = card.querySelector('[data-pixel-price]');
        if (hidden) { hidden.value = variant.id; hidden.disabled = !variant.available; }
        if (price) price.textContent = variant.price;
        if (button) { button.disabled = !variant.available; button.textContent = variant.available ? card.dataset.addLabel : card.dataset.soldLabel; }
      });
    };

    const start = () => document.querySelectorAll('[data-pixel-home]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true }); else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
